import type { FolderRouter } from "replo-publisher-v1/src/trpc/routers/folder";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: folderRouter,
  client: folderClient,
  utils: folderUtils,
  options: folderOptions,
} = createTrpcRouterConfig<FolderRouter>({
  path: "folder",
  queryClient: getNamespacedQueryClient("folder"),
});

export { folderClient, folderRouter, folderUtils, folderOptions };
